import { render, staticRenderFns } from "./QNavbar.vue?vue&type=template&id=2ff203b6&scoped=true"
import script from "./QNavbar.vue?vue&type=script&lang=js"
export * from "./QNavbar.vue?vue&type=script&lang=js"
import style0 from "./QNavbar.vue?vue&type=style&index=0&id=2ff203b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff203b6",
  null
  
)

/* custom blocks */
import block0 from "./QNavbar.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports